'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'loader';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e1d4';
var svgPathData = 'M312 104C312 117.3 301.3 128 288 128C274.7 128 264 117.3 264 104V24C264 10.75 274.7 0 288 0C301.3 0 312 10.75 312 24V104zM312 488C312 501.3 301.3 512 288 512C274.7 512 264 501.3 264 488V408C264 394.7 274.7 384 288 384C301.3 384 312 394.7 312 408V488zM32 256C32 242.7 42.75 232 56 232H136C149.3 232 160 242.7 160 256C160 269.3 149.3 280 136 280H56C42.75 280 32 269.3 32 256zM520 232C533.3 232 544 242.7 544 256C544 269.3 533.3 280 520 280H440C426.7 280 416 269.3 416 256C416 242.7 426.7 232 440 232H520zM469 74.98C478.4 84.35 478.4 99.55 469 108.9L412.5 165.5C403.1 174.9 387.9 174.9 378.5 165.5C369.1 156.1 369.1 140.9 378.5 131.6L435.1 74.98C444.5 65.61 459.6 65.61 469 74.98zM140.9 437C131.5 446.4 116.4 446.4 106.1 437C97.61 427.6 97.61 412.4 106.1 403.1L163.5 346.5C172.9 337.1 188.1 337.1 197.5 346.5C206.9 355.9 206.9 371.1 197.5 380.4L140.9 437zM106.1 74.98C116.4 65.61 131.5 65.61 140.9 74.98L197.5 131.6C206.9 140.9 206.9 156.1 197.5 165.5C188.1 174.9 172.9 174.9 163.5 165.5L106.1 108.9C97.61 99.55 97.61 84.35 106.1 74.98V74.98zM469 403.1C478.4 412.4 478.4 427.6 469 437C459.6 446.4 444.5 446.4 435.1 437L378.5 380.4C369.1 371.1 369.1 355.9 378.5 346.5C387.9 337.1 403.1 337.1 412.5 346.5L469 403.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLoader = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;